import React from "react";
import { Form } from "react-bootstrap";
import { REPORT_TOOLBAR_CLASS } from "@core/reports/constants/reportToolbar";
import type { AvailableLayoutOption } from "@features/presentationLayout/types/presentationLayout";
import { MESSAGE_BINDINGS_INCOMPLETE } from "@features/presentationLayout/constants/presentationLayoutConstants";

type Props = {
  layouts: AvailableLayoutOption[];
  value: string;
  disabled?: boolean;
  onChange: (layout: string) => void;
  testId?: string;
};

/** Report Layout dropdown: the default table plus any named presentation layouts available for this report. */
const ReportLayoutSelector: React.FC<Props> = ({ layouts, value, disabled, onChange, testId = "report-layout-select" }) => {
  const selected = layouts.find((option) => option.layout === value);
  const showIncomplete = Boolean(selected?.bindings_incomplete);

  return (
    <div>
      <Form.Group className="d-flex align-items-center gap-2 mb-0" controlId={testId}>
        <Form.Label className="small fw-semibold mb-0 text-nowrap">Layout</Form.Label>
        <Form.Select
          size="sm"
          className={REPORT_TOOLBAR_CLASS.layoutSelect}
          value={value}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
          data-testid={testId}
        >
          {layouts.map((option) => (
            <option key={option.layout} value={option.layout}>{option.name}</option>
          ))}
        </Form.Select>
      </Form.Group>
      {showIncomplete ? (
        <div className="text-muted small mt-1" data-testid="layout-bindings-incomplete-warning">
          {MESSAGE_BINDINGS_INCOMPLETE}
        </div>
      ) : null}
    </div>
  );
};

export default ReportLayoutSelector;
